export const BLOG_URL = 'https://www.medium.com/overlander';
export const CONTACT_US_EMAIL = 'hello@paideia.io';
